﻿import { useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import Head from "@/components/Content/Head";
import BasePagination from "@/components/Pagination/BasePagination";
import Fetching from "@/components/Fetching/Fetching";
import BasicConfirm from "@/components/Confirm/BasicConfirm";
import CustomersTableHead from "./CustomersTableHead";
import CustomersTableBody from "./CustomersTableBody";
import CustomersForm from "./CustomersForm/CustomersForm";
import classes from "../maintainers.module.scss";

import { useCustomersPaginate, useMutateCustomer, useMutateDeleteCustomer, useMutateStatusCustomer } from "@/hooks/maintainers/customers";
import { base_list } from "./customers.constants";
import { UPDATE_USE_ESTATE_PARENT } from "@/redux/types/auth.types";

const Customers = () => {
	const { customer } = useSelector((state) => state.auth.user);
	const { search } = useSelector((state) => state.auth.filter);
	const { option } = useParams();
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const [base, setBase] = useState({ ...base_list });
	const [showDelete, setShowDelete] = useState(false);
	const [showStatus, setShowStatus] = useState(false);
	const [selected, setSelected] = useState("");

	const { data, isLoading, isFetching } = useCustomersPaginate({
		...base,
		search,
	});
	const { mutate: mutateSave, isLoading: isLoadingSave } = useMutateCustomer({
		...base,
		search,
	});
	const { mutate: mutateDelete, isLoading: isLoadingDelete } = useMutateDeleteCustomer({
		...base,
		search,
	});
	const { mutate: mutateStatus, isLoading: isLoadingStatus } = useMutateStatusCustomer({
		...base,
		search,
	});

	const { customers: list, tools, countries, categories } = data ? data : {};
	const { data: customers, last_page, total, from, to } = list ? list : {};

	const handleDelete = (item) => {
		setSelected(item.id);
		setShowDelete(true);
	};

	const handleStatus = (item) => {
		setSelected(item.id);
		setShowStatus(true);
	};

	const confirmDelete = () => {
		mutateDelete(
			{ ...base, search, selected },
			{
				onSuccess: () => {
					setSelected("");
					setShowDelete(false);
					toast.success("Cliente eliminado correctamente.");
				},
			},
		);
	};

	const confirmStatus = () => {
		mutateStatus(
			{ ...base, search, selected },
			{
				onSuccess: () => {
					setSelected("");
					setShowStatus(false);
					toast.success("Se cambió el estado del cliente correctamente. Si el cliente es inactivo, no podrá iniciar sesión.");
				},
			},
		);
	};

	const confirmSave = (data) => {
		mutateSave(
			{ ...base, search, params: { ...data } },
			{
				onSuccess: (response) => {
					const { detail } = response || {};
					if (detail && detail.id === customer.id) {
						dispatch({ type: UPDATE_USE_ESTATE_PARENT, payload: { use_estate_parent: detail.use_estates_parents } });
					}

					toast.success("Cliente guardado correctamente.");
				},
			},
		);
	};

	const setPage = (value) => setBase({ ...base, page: value });
	const setOrder = (value) => setBase({ ...base, order: value });
	const setOrderType = (value) => setBase({ ...base, orderType: value });
	const setPaginate = (value) => setBase({ ...base, paginate: value });

	if (isLoading || isLoadingDelete || isLoadingStatus) {
		return <Fetching />;
	}

	return (
		<>
			<Head
				title="Clientes"
				button={true}
				button_text={"Nuevo Cliente"}
				action={() => navigate("/mantenedores/clientes/crear")}
				back_url={"/mantenedores"}
				isFetching={isFetching}
			/>

			<Row className={` ${classes.main_row}`}>
				<Col md={12} className={classes.main_col}>
					<Row className={classes.table}>
						<div className={classes.table_div}>
							<Table className={classes.table_desktop}>
								<CustomersTableHead order={base.order} setOrder={setOrder} orderType={base.orderType} setOrderType={setOrderType} />

								<CustomersTableBody customers={customers} categories={categories} handleDelete={handleDelete} handleStatus={handleStatus} />
							</Table>
						</div>
					</Row>

					<BasePagination
						page={base.page}
						paginate={base.paginate}
						last_page={last_page}
						quantity={total}
						from={from}
						to={to}
						setPage={setPage}
						setPaginate={setPaginate}
					/>
				</Col>
			</Row>

			<BasicConfirm
				showConfirm={showDelete}
				setShowConfirm={setShowDelete}
				handleAction={confirmDelete}
				showValidation={true}
				textValidation={"eliminar cliente"}
			/>

			<BasicConfirm
				showConfirm={showStatus}
				setShowConfirm={setShowStatus}
				handleAction={confirmStatus}
				showValidation={true}
				textValidation={"cambiar estado del cliente"}
			/>

			{option && <CustomersForm confirmSave={confirmSave} isLoadingSave={isLoadingSave} tools={tools} countries={countries} categories={categories} />}
		</>
	);
};

export default Customers;
